import { useLocale } from "lib/i18n/client";
import { localeToIntlCode } from "lib/i18n/config";
import { getTranslations } from "lib/i18n/dictionary";

export function useSiteTranslations() {
  const locale = useLocale();
  return {
    locale,
    intlLocale: localeToIntlCode[locale],
    t: getTranslations(locale).sitePage,
  };
}
